<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="1"></Navigation>
    </div>
    <div class="right">
      <!-- 标 -->
      <img
        class="bar"
        @click="goUrl('/module/invite')"
        src="@/assets/image/homepage/bar.png"
      />
      <!-- 签到 -->
      <div class="sign-box">
        <div class="sign">
          <div class="sign-top">
            <div class="sign-top-left">
              <img
                class="head"
                v-if="$store.state.userInfo.avatarUrl"
                :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
              />
              <img class="head" v-else src="@/assets/image/module/head.png" />
              <div class="grade-box">
                <div class="name">{{ $store.state.userInfo.userName }}</div>
                <div class="grade" :title="getName">
                  <img
                    class="grade-img"
                    :src="require(`@/assets/image/homepage/v${this.grade}.png`)"
                  />
                  <span>{{ $t("module.homepage.title1") }}</span>
                </div>
              </div>
            </div>
            <div
              :class="`sign-top-right ${
                answerRegisterStatus.signed ? 'sign-top-right-istrue' : ''
              } ${flag ? 'sign-top-right-flag' : ''}`"
              @click="openShow"
            >
              <img class="sign-img" src="@/assets/image/homepage/sign.png" />

              <span v-if="!answerRegisterStatus.signed && !flag">
                {{ $t("module.homepage.title2") }}
              </span>
              <span v-else-if="!answerRegisterStatus.signed && flag"
                ><i class="el-icon-refresh-right refresh"></i
                >{{ $t("module.homepage.signing") }}</span
              >
              <span v-else>{{ $t("module.homepage.signed") }}</span>
            </div>
          </div>

          <div class="progress" ref="progress">
            <div class="progress-icon">
              <el-progress
                :percentage="percentage"
                :show-text="false"
                :stroke-width="11"
              ></el-progress>
              <img
                ref="fiveStar"
                class="five-star"
                src="@/assets/image/homepage/five-star.png"
                :alt="$t('module.homepage.fiveStarAlt')"
              />
            </div>
            <div class="progress-grade">
              <span>v{{ grade }}</span>
              <span>v{{ grade + 1 }}</span>
            </div>
            <div class="progress-gap">
              <div>{{ $t("module.homepage.title3") }}</div>
              <div class="number">{{ credit }}/{{ behindNumer }}</div>
            </div>
          </div>
        </div>
        <div class="gold">
          <div class="horn-box">
            <img class="horn" src="@/assets/image/homepage/horn.png" />

            <div
              class="late-box"
              ref="boxRef"
              v-if="latestNews.length !== 0"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
            >
              <transition-group name="scroll" tag="div" class="scroll-wrapper">
                <div
                  class="late-item"
                  v-for="(item, index) in latestNews"
                  @click="goUrl(`/module/latestNew?id=${item.id}`)"
                  :key="item.id"
                >
                  {{ item.title }}
                </div>
              </transition-group>
            </div>

            <div v-else>{{ $t("module.homepage.noData") }}</div>
          </div>
          <div class="cards">
            <div class="card-box">
              <div class="top">
                <div class="check" @click="goUrl('/module/goldHistory')">
                  {{ $t("module.homepage.title7") }}
                </div>
              </div>
              <div class="bottom">
                <img src="@/assets/image/homepage/gold.png" />
                <div class="text-box">
                  <div class="number">{{ userInfo.balance }}</div>
                  <div class="name">{{ $t("module.homepage.title4") }}</div>
                </div>
              </div>
            </div>
            <div class="card-box">
              <div class="top">
                <div class="check" @click="goUrl('/module/credits')">
                  {{ $t("module.homepage.title7") }}
                </div>
              </div>
              <div class="bottom">
                <img src="@/assets/image/homepage/xinyongzhi.png" />
                <div class="text-box">
                  <div class="number">{{ credit }}</div>
                  <div class="name">{{ $t("module.homepage.title5") }}</div>
                </div>
              </div>
            </div>
            <div class="coefficient-box">
              <div class="coefficient">X{{ incomePromote }}</div>
              <div class="name">{{ $t("module.homepage.title6") }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 签到移动端 -->
      <div class="sign-box-mobie">
        <div class="horn-box">
          <img class="horn" src="@/assets/image/homepage/horn.png" />
          <span>{{ $t("module.homepage.placeholderText") }}</span>
        </div>
        <div class="sign">
          <div class="sign-top">
            <div class="sign-top-left">
              <img
                class="head"
                v-if="$store.state.userInfo.avatarUrl"
                :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
              />
              <img class="head" v-else src="@/assets/image/module/head.png" />
              <div class="grade-box">
                <div class="name">{{ $store.state.userInfo.userName }}</div>
                <div class="grade">
                  <img
                    class="grade-img"
                    :src="require(`@/assets/image/homepage/v${this.grade}.png`)"
                  />
                  <span>{{ $t("module.homepage.title1") }}</span>
                </div>
              </div>
            </div>
            <div
              :class="`sign-top-right ${
                answerRegisterStatus.signed ? 'sign-top-right-istrue' : ''
              } ${flag ? 'sign-top-right-flag' : ''}`"
              @click="openShow"
            >
              <img class="sign-img" src="@/assets/image/homepage/sign.png" />

              <span v-if="!answerRegisterStatus.signed && !flag">
                {{ $t("module.homepage.title2") }}
              </span>
              <span v-else-if="!answerRegisterStatus.signed && flag"
                ><i class="el-icon-refresh-right refresh"></i
                >{{ $t("module.homepage.signing") }}</span
              >
              <span v-else>{{ $t("module.homepage.signed") }}</span>
            </div>
          </div>

          <div class="progress-fa">
            <div class="progress">
              <div class="progress-icon">
                <el-progress
                  ref="progress"
                  id="progress"
                  :percentage="percentage"
                  :show-text="false"
                  :stroke-width="11"
                ></el-progress>
                <img
                  ref="fiveStar"
                  class="five-star"
                  src="@/assets/image/homepage/five-star.png"
                  :alt="$t('module.homepage.fiveStarAlt')"
                />
              </div>
              <div class="progress-grade">
                <span>v{{ grade }}</span>
                <span>v{{ grade + 1 }}</span>
              </div>
              <div class="progress-gap">
                <div>{{ $t("module.homepage.title3") }}</div>
                <div class="number">{{ credit }}/{{ behindNumer }}</div>
              </div>
            </div>
            <div class="coefficient-box">
              <div class="coefficient">X{{ incomePromote }}</div>
              <div class="name">{{ $t("module.homepage.title6") }}</div>
            </div>
          </div>
          <div class="cards">
            <div class="card-box">
              <div class="bottom">
                <img src="@/assets/image/homepage/gold.png" />
                <div class="text-box">
                  <div class="number">{{ userInfo.balance }}</div>
                  <div class="name">{{ $t("module.homepage.title4") }}</div>
                </div>
              </div>
            </div>
            <div class="card-box">
              <div class="bottom">
                <img src="@/assets/image/homepage/xinyongzhi.png" />
                <div class="text-box">
                  <div class="number">{{ credit }}</div>
                  <div class="name">{{ $t("module.homepage.title5") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="gold">
          <div class="cards">
            <div class="card-box">
              <div class="top">
                <div class="check">{{ $t("module.homepage.title7") }}</div>
              </div>
              <div class="bottom">
                <img src="@/assets/image/homepage/gold.png" />
                <div class="text-box">
                  <div class="number">100</div>
                  <div class="name">{{ $t("module.homepage.title4") }}</div>
                </div>
              </div>
            </div>
            <div class="card-box">
              <div class="top">
                <div class="check">{{ $t("module.homepage.title7") }}</div>
              </div>
              <div class="bottom">
                <img src="@/assets/image/homepage/xinyongzhi.png" />
                <div class="text-box">
                  <div class="number">100</div>
                  <div class="name">{{ $t("module.homepage.title5") }}</div>
                </div>
              </div>
            </div>
            <div class="coefficient-box">
              <div class="coefficient">X1.0</div>
              <div class="name">{{ $t("module.homepage.title6") }}</div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 任务列表 -->
      <div class="task-herder">
        <div>{{ $t("module.homepage.title8") }}</div>
        <div class="check" @click="goUrl('/module/task')">
          {{ $t("module.homepage.title9")
          }}<img
            class="arrow-right"
            src="@/assets/image/homepage/arrow-right.png"
          />
        </div>
      </div>

      <div class="task-list">
        <div class="task-item" v-for="(item, index) in list" :key="index">
          <div class="task-item-top">
            <div class="name">{{ item.title }}</div>
            <div class="task-right">
              <div class="equipment">{{ $t("module.homepage.title10") }}:</div>
              <img
                v-if="item.deviceType === 2 || item.deviceType === 1"
                src="@/assets/image/homepage/pc.png"
              />
              <img
                v-if="item.deviceType === 1 || item.deviceType === 3"
                src="@/assets/image/homepage/phone.png"
              />
            </div>
          </div>
          <div class="task-item-content">
            <div class="star-box">
              <img
                v-for="cItem in Math.floor(item.IR / 20)"
                :key="cItem"
                src="@/assets/image/homepage/star.png"
              />
              <img
                v-for="cItem in 5 - Math.floor(item.IR / 20)"
                :key="cItem + Math.floor(item.IR / 20) + 1"
                src="@/assets/image/homepage/star-while.png"
              />
            </div>
            <div class="golds">
              {{ item.minPoints }}~{{ item.maxPoints
              }}<span>{{ $t("module.homepage.title11") }}</span>
            </div>
          </div>
          <div class="task-item-bottom">
            <div class="task-clock">
              <img class="clock" src="@/assets/image/homepage/clock.png" />
              <div>{{ item.LOI }}{{ $t("module.homepage.title12") }}</div>
            </div>
            <div class="task-text-box">
              <div
                class="show"
                v-if="item.allowedHide"
                @click="setIgnoreSurvey(item.id, index)"
              >
                {{ $t("module.homepage.title13") }}
              </div>
              <div
                class="many"
                @click="
                  goUrl(
                    `/module/taskDetails?id=${
                      item.multiple ? item.id : item.encryptId
                    }`
                  )
                "
              >
                {{
                  item.multiple
                    ? $t("module.homepage.multipleCompletion")
                    : $t("module.homepage.participateNow")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mask"
      v-if="answerRegisterStatus.answerDialogVisible"
      @click="close"
    ></div>

    <div class="sign-in" v-if="answerRegisterStatus.answerDialogVisible">
      <div class="sign-box">
        <div class="close-box" @click="close">
          <img class="close" src="@/assets/image/module/close.png" />
        </div>

        <div class="content-box">
          <div class="register-calendar-main">
            <div class="big-month-bg">{{ month }}</div>
            <div
              class="register-calendar-week"
              v-for="item in weekList"
              :key="item"
            >
              <div>{{ item }}</div>
            </div>
            <div
              class="register-calendar-day"
              v-for="(item, index) in answerRegisterStatus.dateList"
              :key="index"
            >
              <div
                :class="
                  item.bgColor
                    ? 'register-calendar-day-item lastday'
                    : 'register-calendar-day-item'
                "
              >
                <span v-if="!item.isRmb">{{ item.day }}</span>
                <img
                  v-else
                  class="rmb"
                  src="@/assets/image/gold-coin.png"
                  :alt="$t('module.homepage.imageAlt')"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="sign-date">
          {{ $t("module.homepage.title19") }}
          <span>{{ answerRegisterStatus.totalDays }}</span>
          {{ $t("module.homepage.title21") }}
        </div>

        <div class="sign-name-box">
          <span></span>
          <div>{{ $t("module.homepage.todaySigned") }}</div>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import {
  getAccount,
  getSignedDays,
  getSigned,
  setSignin,
  getIndividualSurveys,
  setIgnoreSurvey,
  getLatestNews,
} from "@/api/user";
import { getDateList } from "@/utils/calendar";
export default {
  data() {
    return {
      userInfo: {},
      menuTop: 86,
      percentage: 0,
      grade: 1,
      credit: 0,
      behindNumer: 0,
      list: [],
      show: false,
      answerRegisterStatus: {
        answerDialogVisible: false, //弹框
        dateList: [],
        answerIndex: "",
        signed: false, //今天是否签到
        totalDays: 0, //连续签到天数
      },
      incomePromote: "1.0",
      flag: false,
      month: 1,
      latestNews: [], // 最新公告
      timer: null, // 用来存放定时器
    };
  },
  components: { Navigation },
  computed: {
    weekList() {
      // 使用 Intl API 动态获取当前语言环境下的星期名称
      const weekDays = [];
      const date = new Date();
      // 找到最近的一个周日作为起点，或者直接遍历 0-6
      for (let i = 0; i < 7; i++) {
        // 2023-01-01 是周日
        const d = new Date(2023, 0, 1 + i);
        weekDays.push(
          new Intl.DateTimeFormat(this.$i18n.locale || "zh-CN", {
            weekday: "short",
          }).format(d)
        );
      }
      return weekDays;
    },
    getName() {
      let name = "铁牌";
      switch (this.grade) {
        case 1:
          name = "铁牌";
          break;
        case 2:
          name = "铜牌";
          break;
        case 3:
          name = "银牌";
          break;
        case 4:
          name = "金牌";
          break;
        case 5:
          name = "钻石";
          break;
        case 6:
          name = "王者";
          break;
      }

      return name + "会员";
    },
  },
  methods: {
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },
    //获取任务列表
    async getIndividualSurveys() {
      await getIndividualSurveys().then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.list = res.data.list;
        }
      });
    },
    getGrade() {
      if (this.userInfo.credit <= 60) {
        return 1;
      }
      if (61 <= this.userInfo.credit && this.userInfo.credit <= 100) {
        return 2;
      }
      if (101 <= this.userInfo.credit && this.userInfo.credit <= 200) {
        return 3;
      }
      if (201 <= this.userInfo.credit && this.userInfo.credit <= 500) {
        return 4;
      }
      if (501 <= this.userInfo.credit && this.userInfo.credit <= 800) {
        return 5;
      }
      if (801 <= this.userInfo.credit && this.userInfo.credit <= 1000) {
        return 6;
      }
      return 1;
    },
    async openShow() {
      if (this.answerRegisterStatus.signed) {
        this.answerRegisterStatus.answerDialogVisible = true;
      } else {
        if (this.flag) {
          return;
        }
        await this.setSignin();
      }
    },
    close() {
      this.answerRegisterStatus.answerDialogVisible = false;
    },

    //签到
    async setSignin() {
      this.flag = true;
      await setSignin()
        .then(async (res) => {
          this.flag = false;
          if (res.code === 200) {
            this.$message.success("签到成功");
            await this.getSignedDays();
            this.answerRegisterStatus.signed = res.data.signed;
            this.answerRegisterStatus.totalDays = res.data.totalDays;
            this.answerRegisterStatus.answerDialogVisible = true;
          }
        })
        .catch(() => {
          this.flag = false;
        });
    },

    //签到记录
    async getSignedDays() {
      await getSignedDays().then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length !== 0) {
            const newDays = res.data.map((item) => item.day);
            this.answerRegisterStatus.dateList = getDateList(newDays);
          } else {
            this.answerRegisterStatus.dateList = getDateList([]);
          }
        }
      });
    },

    //今日是否签到
    async getSigned() {
      await getSigned().then((res) => {
        if (res.code === 200) {
          this.answerRegisterStatus.signed = res.data.signed;
          this.answerRegisterStatus.totalDays = res.data.totalDays;
        }
      });
    },

    //忽略
    setIgnoreSurvey(id, index) {
      this.$confirm(
        "此调查，如果提示您参加过或者您不愿意参加，您可以隐藏本项目。隐藏后，您将无法再参与本项目，请确认是否隐藏？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          confirmButtonClass: "confirmButtonText",
        }
      )
        .then(() => {
          setIgnoreSurvey({ id }).then((res) => {
            if (res.code === 200) {
              this.$message.success("隐藏成功");
              this.list.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    goUrl(path) {
      this.$router.push(path);
    },

    startScroll() {
      // 每隔 2.5 秒，把数组的第一条移到最后，触发 Vue 的过渡动画
      this.timer = setInterval(() => {
        const box = this.$refs.boxRef;
        // 获取单条数据的高度 (例如 52px)
        const itemHeight = box.offsetHeight;

        // 1. 获取列表的第一个元素
        const firstItem = box.querySelector(".late-item");

        // 2. 给它添加一个“向上消失”的类名
        firstItem.classList.add("scroll-leave-active");
        firstItem.style.transform = `translateY(-${itemHeight}px)`;
        firstItem.style.opacity = 0;

        // 3. 等待动画结束 (这里设置 500ms，要和 CSS 里的 transition 时间一致)
        setTimeout(() => {
          // 4. 把第一个元素移到最后
          box.appendChild(firstItem);

          // 5. 移除类名，重置样式，让它瞬间回到列表底部（用户看不见底部，所以不会闪烁）
          firstItem.classList.remove("scroll-leave-active");
          firstItem.style.transform = "translateY(0)";
          firstItem.style.opacity = 1;
        }, 500);
      }, 3000); // 3000ms = 3秒停留时间
    },
    clearScroll() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 鼠标移入：暂停
    handleMouseEnter() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 鼠标移出：继续
    handleMouseLeave() {
      this.startScroll();
    },
  },
  async created() {
    window.addEventListener("scroll", this.listenScroll);

    await this.getSigned();
    await this.getSignedDays();
    const date = new Date();
    this.month = date.getMonth() + 1; // 获取当前月份（1-12）
  },
  async mounted() {
    await getAccount().then((res) => {
      if (res.code === 200) {
        this.userInfo = res.data;
        this.$store.commit("changeUserInfo", this.userInfo);
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    });

    // 获取最新公告
    await getLatestNews().then((res) => {
      if (res.code === 200) {
        this.latestNews = res.data;
        console.log("this.latestNews", this.latestNews);
      }
    });

    this.credit = this.userInfo.credit;
    this.grade = this.getGrade();
    switch (this.grade) {
      case 1:
        this.gradeName = "一般";
        this.frontNumber = 0;
        this.behindNumer = 60;
        this.incomePromote = "1.0";
        this.differenceNuber = 61 - this.userInfo.credit;
        break;
      case 2:
        this.gradeName = "中等";
        this.frontNumber = 61;
        this.behindNumer = 100;
        this.incomePromote = "1.05";
        this.differenceNuber = 101 - this.userInfo.credit;
        break;
      case 3:
        this.gradeName = "良好";
        this.frontNumber = 101;
        this.behindNumer = 200;
        this.incomePromote = "1.1";
        this.differenceNuber = 201 - this.userInfo.credit;
        break;
      case 4:
        this.gradeName = "优秀";
        this.frontNumber = 201;
        this.behindNumer = 500;
        this.incomePromote = "1.15";
        this.differenceNuber = 501 - this.userInfo.credit;
        break;
      case 5:
        this.gradeName = "钻石";
        this.frontNumber = 501;
        this.behindNumer = 800;
        this.incomePromote = "1.2";
        this.differenceNuber = 801 - this.userInfo.credit;
        break;
      case 6:
        this.gradeName = "王者";
        this.frontNumber = 801;
        this.behindNumer = 1000;
        this.incomePromote = "1.4";
        break;
    }
    this.percentage = (this.credit * 100) / this.behindNumer;
    // const left = (document.getElementById('progress').offsetWidth * this.percentage) / 100;
    document.getElementsByClassName(
      "five-star"
    )[0].style.left = `${this.percentage}%`;
    await this.getIndividualSurveys();
    if (this.latestNews.length !== 0) {
      this.startScroll();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
  beforeDestroy() {
    // 组件销毁前清除定时器，防止内存泄漏
    this.clearScroll();
  },
};
</script>
<style scoped>
.circle >>> svg > path:nth-child(2) {
  stroke: url(#write);
}
.circle >>> .el-progress__text {
  display: none;
}
.progress >>> .el-progress-bar__inner {
  background: linear-gradient(90deg, #ffa200 0%, #ff6c00 100%);
}
</style>
<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
    // 标
    .bar {
      width: 100%;
      border-radius: 4px;
      cursor: pointer;
    }
    // 签到
    .sign-box {
      display: flex;
      margin-top: 16px;
      .sign {
        flex-shrink: 0;
        margin-right: 16px;
        width: 327px;
        height: 250px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        .sign-top {
          display: flex;
          justify-content: space-between;
          margin-top: 26px;
          .sign-top-left {
            display: flex;
            align-items: center;
            margin-left: 15px;
            .head {
              width: 52px;
              height: 52px;
              border-radius: 26px;
              margin-right: 15px;
            }
            .grade-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .name {
                font-size: 16px;
                color: #474f66;
                margin-bottom: 9px;
              }
              .grade {
                display: flex;
                align-items: center;
                padding: 0 10px;
                height: 22px;
                border-radius: 11px;
                background: #f3ecff;
                color: #8948ff;
                font-size: 12px;
                .grade-img {
                  width: 16px;
                  height: 16px;
                  margin-right: 5px;
                }
              }
            }
          }
          .sign-top-right {
            width: 65px;
            height: 81px;
            background: linear-gradient(319deg, #8948ff 0%, #9e90ff 100%);
            border-radius: 6px 6px 6px 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 12px;
            margin-right: 33px;
            cursor: pointer;
            .sign-img {
              width: 18px;
              height: 18px;
              margin-bottom: 11px;
            }
          }
          .sign-top-right-istrue {
            opacity: 0.5;
          }
          .sign-top-right-flag {
            cursor: no-drop;
          }
        }
        .progress {
          width: calc(100% - 50px);
          margin-top: 56px;
          margin-left: 25px;
          .progress-icon {
            position: relative;
            width: 100%;

            .five-star {
              position: absolute;
              top: -10px;
              width: 30px;
              height: 30px;
              transform: translateX(-50%);
            }
          }
          .progress-grade {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            font-size: 12px;
            font-weight: bold;
            color: #232323;
          }
          .progress-gap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #333333;
            margin-top: 10px;
            .number {
              font-size: 16px;
              font-weight: bold;
              color: #ffa200;
            }
          }
        }
      }
      .gold {
        width: 100%;
        height: 250px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        padding: 30px;
        box-sizing: border-box;
        .horn-box {
          width: 100%;
          height: 52px;
          background: rgba(137, 72, 255, 0.05);
          border-radius: 4px 4px 4px 4px;
          color: #8948ff;
          font-size: 14px;
          display: flex;
          align-items: center;
          .horn {
            width: 18px;
            height: 18px;
            margin: 0 18px 0 25px;
          }
          .late-box {
            height: 52px;
            overflow: hidden;
            width: calc(100% - 79px);
            position: relative;

            .late-item {
              width: 100%;
              height: 52px;
              line-height: 52px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              /* 开启 transition，让 JS 改变的 transform 产生动画效果 */
              transition: all 0.5s ease;
              cursor: pointer;
            }
          }
        }
        .cards {
          display: flex;
          justify-content: space-between;
          margin-top: 40px;
          .card-box {
            display: flex;
            flex-direction: column;
            .top {
              display: flex;
              justify-content: flex-end;
              .check {
                padding: 0 10px;
                height: 18px;
                background: #fff7e5;
                border-radius: 9px 9px 9px 9px;
                line-height: 18px;
                color: #ffb202;
                font-size: 10px;
                cursor: pointer;
              }
            }
            .bottom {
              display: flex;
              align-items: center;
              margin-right: 60px;
              img {
                width: 60px;
                height: 60px;
                margin-right: 18px;
              }
              .text-box {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                text-align: center;
                .number {
                  font-size: 34px;
                  color: #474f66;
                  font-weight: bolder;
                }
                .name {
                  font-size: 14px;
                  color: #474f66;
                }
              }
            }
          }
          .coefficient-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            .coefficient {
              font-size: 34px;
              color: #474f66;
              font-weight: bolder;
              margin-top: 18px;
            }
            .name {
              font-size: 14px;
              color: #474f66;
            }
          }
        }
      }
    }

    .sign-box-mobie {
      display: none;
      flex-direction: column;
      .horn-box {
        width: 100%;
        padding: 10px 0;
        background: rgba(137, 72, 255, 0.05);
        border-radius: 4px 4px 4px 4px;
        color: #8948ff;
        font-size: 14px;
        display: flex;
        align-items: center;
        margin: 10px 0 8px 0;
        .horn {
          width: 18px;
          height: 18px;
          margin: 0 18px 0 25px;
        }
      }
      .sign {
        flex-shrink: 0;
        margin-right: 16px;
        width: 100%;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        .sign-top {
          display: flex;
          justify-content: space-between;
          margin-top: 26px;
          .sign-top-left {
            display: flex;
            align-items: center;
            margin-left: 15px;
            .head {
              width: 52px;
              height: 52px;
              border-radius: 26px;
              margin-right: 15px;
            }
            .grade-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .name {
                font-size: 16px;
                color: #474f66;
                margin-bottom: 9px;
              }
              .grade {
                display: flex;
                align-items: center;
                padding: 0 10px;
                height: 22px;
                border-radius: 11px;
                background: #f3ecff;
                color: #8948ff;
                font-size: 12px;
                .grade-img {
                  width: 16px;
                  height: 16px;
                  margin-right: 5px;
                }
              }
            }
          }
          .sign-top-right {
            width: 65px;
            height: 81px;
            background: linear-gradient(319deg, #8948ff 0%, #9e90ff 100%);
            border-radius: 6px 6px 6px 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 12px;
            margin-right: 33px;
            cursor: pointer;
            .sign-img {
              width: 18px;
              height: 18px;
              margin-bottom: 11px;
            }
          }
          .sign-top-right-istrue {
            opacity: 0.7;
          }
        }
        .progress-fa {
          width: calc(100% - 50px);
          display: flex;
          align-items: center;
          margin-left: 25px;
          margin-top: 26px;
          .progress {
            width: 100%;
            .progress-icon {
              position: relative;
              width: 100%;
              .five-star {
                position: absolute;
                top: -10px;
                width: 30px;
                height: 30px;
              }
            }
            .progress-grade {
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
              font-size: 12px;
              font-weight: bold;
              color: #232323;
            }
            .progress-gap {
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 12px;
              color: #333333;
              margin-top: 10px;
              .number {
                font-size: 16px;
                font-weight: bold;
                color: #ffa200;
              }
            }
          }
          .coefficient-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-shrink: 0;
            text-align: center;
            margin-left: 22px;
            .coefficient {
              font-size: 24px;
              color: #474f66;
              font-weight: bolder;
              margin-bottom: 16px;
            }
            .name {
              font-size: 14px;
              color: #474f66;
            }
          }
        }
        .cards {
          display: flex;
          justify-content: space-between;
          margin-top: 40px;
          margin-bottom: 17px;
          width: calc(100% - 50px);
          margin-left: 25px;
          .card-box {
            display: flex;
            flex-direction: column;

            .bottom {
              display: flex;
              align-items: center;
              img {
                width: 54px;
                height: 54px;
                margin-right: 18px;
              }
              .text-box {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                text-align: center;
                .number {
                  font-size: 24px;
                  color: #474f66;
                  font-weight: bolder;
                }
                .name {
                  font-size: 14px;
                  color: #474f66;
                }
              }
            }
          }
        }
      }
    }
    //任务列表
    .task-herder {
      display: flex;
      justify-content: space-between;
      color: #474f66;
      font-size: 20px;
      margin-top: 35px;
      margin-bottom: 20px;
      .check {
        display: flex;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
      }
      .arrow-right {
        width: 16px;
        height: 16px;
        margin-left: 10px;
      }
    }
    .task-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .task-item {
        width: calc((100% - 32px) / 3);
        height: 186px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        margin-bottom: 16px;
        padding: 20px;
        box-sizing: border-box;
        margin-right: 16px;
        .task-item-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            font-size: 16px;
            font-weight: bolder;
            color: #232323;
          }
          .task-right {
            display: flex;
            align-items: center;
            .equipment {
              font-size: 12px;
              color: #999999;
              white-space: nowrap;
            }
            img {
              width: 16px;
              height: 16px;
              margin-left: 6px;
            }
          }
        }
        .task-item-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 48px;
          .star-box {
            display: flex;
            img {
              width: 15px;
              height: 16px;
            }
          }
          .golds {
            color: #8948ff;
            font-weight: bolder;
            font-size: 22px;
            span {
              font-size: 12px;
              color: #232323;
              font-weight: normal;
              margin-left: 10px;
            }
          }
        }
        .task-item-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 18px;
          .task-clock {
            color: #999999;
            font-size: 12px;
            display: flex;
            align-items: center;
            .clock {
              width: 14px;
              height: 14px;
              margin-right: 2px;
            }
          }
          .task-text-box {
            display: flex;
            align-items: center;
            .show {
              font-size: 14px;
              color: #474f66;
              margin-right: 28px;
              cursor: pointer;
            }
            .many {
              cursor: pointer;
              width: 104px;
              height: 32px;
              line-height: 32px;
              text-align: center;
              color: #fff;
              background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
              box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
              border-radius: 16px 16px 16px 16px;
              font-size: 14px;
            }
          }
        }
      }
      .task-item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .mask {
    position: fixed; /* 定位方式 */
    top: 0; /* 顶部对齐 */
    left: 0; /* 左边对齐 */
    right: 0; /* 右边对齐 */
    bottom: 0; /* 底部对齐 */
    background: rgba(0, 0, 0, 0.5); /* 遮罩层颜色，半透明 */
    z-index: 100; /* 层叠顺序 */
    width: 100%;
    height: 100%;
  }
  .sign-in {
    position: fixed; /* 定位方式 */
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
    width: 455px;
    height: 520px;
    z-index: 101; /* 层叠顺序 */
    background-image: url("../assets/image/module/bg7.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    .sign-box {
      position: relative;
      width: 100%;
      height: 100%;
      .close-box {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -50px;
        background: #ff9800;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 15px;
        cursor: pointer;
        .close {
          width: 15px;
          height: 15px;
        }
      }
      .content-box {
        padding: 110px 18px 0 18px;
        color: #232323;
      }
      .sign-date {
        text-align: center;
        margin-top: 25px;
        font-size: 14px;
        color: #474f66;
        span {
          font-size: 20px;
          color: #8948ff;
          font-weight: bolder;
        }
      }
      .sign-btn {
        width: 161px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
        border-radius: 23px 23px 23px 23px;
        font-size: 18px;
        color: #fff;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 24px;
      }
    }
  }
}
.sign-name-box {
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  margin-top: 20px;
  color: #8948ff;
  font-size: 14px;
  font-weight: bolder;
  span {
    width: 100px;
    height: 1px;
    background-color: #999;
    margin: 0 10px;
  }
}
.register-calendar-main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  .big-month-bg {
    position: absolute; /* 绝对定位 */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* 完美居中 */
    font-size: 260px; /* 极大的字号 */
    font-weight: 900;
    color: #3498db; /* 经典复古蓝 */
    opacity: 0.12; /* 极低透明度，形成水印背景感 */
    z-index: 0; /* 放在最底层 */
    pointer-events: none; /* 防止挡住下方日期的点击 */
  }
}
.register-calendar-week {
  width: 14.285%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 12px;
  margin-top: 10px;
  color: #0a0a0a;
}
.register-calendar-day {
  width: 14.285%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  color: #0a0a0a;
}

.register-calendar-day-item {
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 5px;
  /* cursor: pointer; */
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lastday {
  color: #dac5c5;
  cursor: auto;
}

.rmb {
  width: 22px;
  height: 22px;
}
/* Vue 过渡动画 */
.scroll-enter-active,
.scroll-leave-active {
  transition: all 0.5s ease;
}
.scroll-enter-from {
  transform: translateY(52px); /* 新条目从底部进入 */
  opacity: 0;
}
.scroll-leave-to {
  transform: translateY(-52px); /* 旧条目向顶部离开 */
  opacity: 0;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}
@media only screen and (max-width: 1150px) {
  .homePage {
    .right {
      .task-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .task-item {
          width: calc((100% - 16px) / 2);
        }
        .task-item:nth-child(3n) {
          margin-right: 16px;
        }
        .task-item:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
      .sign-box {
        display: none;
      }
      .sign-box-mobie {
        display: flex;
      }
    }
  }
}

@media only screen and (max-width: 700px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      .task-list {
        .task-item {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }
  }
}
@media only screen and (max-width: 450px) {
  .homePage {
    .coefficient-box {
      .coefficient {
        font-size: 20px !important;
      }
      .name {
        font-size: 12px;
      }
    }
    .progress-gap {
      .number {
        font-size: 12px !important;
      }
    }
    .card-box {
      .bottom {
        img {
          width: 40px !important;
          height: 40px !important;
        }
      }
      .text-box {
        .number {
          font-size: 14px !important;
        }
        .name {
          font-size: 12px !important;
        }
      }
    }
    .task-herder {
      font-size: 16px !important;
    }

    .sign-in {
      position: fixed; /* 定位方式 */
      top: 2%;
      left: 50%;
      transform: translateX(-50%);
      width: 100vw;
      height: 114vw;
      z-index: 101; /* 层叠顺序 */
      background-image: url("../assets/image/module/bg7.png");
      background-size: cover;
      background-position: 100% 100%;
      background-repeat: no-repeat;
      .sign-box {
        position: relative;
        width: 100%;
        height: 100%;
        .close {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -8.4vw;
          width: 4.2vw;
          height: 4.2vw;
          cursor: pointer;
        }
        .content-box {
          padding: 21vw 3.78vw 0 3.78vw;
          color: #232323;
        }
        .sign-date {
          text-align: center;
          margin-top: 5.25vw;
          font-size: 2.94vw;
          color: #474f66;
          span {
            font-size: 4.2vw;
            color: #8948ff;
            font-weight: bolder;
          }
        }
        .sign-btn {
          width: 161px;
          height: 42px;
          line-height: 42px;
          text-align: center;
          background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
          border-radius: 23px 23px 23px 23px;
          font-size: 18px;
          color: #fff;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 24px;
        }
      }
    }

    .sign-name-box {
      display: flex;
      justify-content: center;
      width: 100%;
      align-items: center;
      margin-top: 4.2vw;
      color: #8948ff;
      font-size: 2.94vw;
      font-weight: bolder;
      span {
        width: 21vw;
        height: 1px;
        background-color: #999;
        margin: 0 2.1vw;
      }
    }
    .register-calendar-main {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .register-calendar-week {
      width: 14.285%;
      height: 10.5vw;
      line-height: 10.5vw;
      text-align: center;
      font-size: 2.52vw;
      margin-top: 2.1vw;
      color: #0a0a0a;
    }
    .register-calendar-day {
      width: 14.285%;
      height: 8.4vw;
      line-height: 8.4vw;
      text-align: center;
      font-size: 2.52vw;
      color: #0a0a0a;
    }

    .register-calendar-day-item {
      width: 8.4vw;
      height: 8.4vw;
      background-color: #fff;
      border-radius: 1.05vw;
      /* cursor: pointer; */
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .lastday {
      color: #dac5c5;
      cursor: auto;
    }

    .rmb {
      width: 4.62vw;
      height: 4.62vw;
    }
  }
}
</style>
<style scoped>
.refresh {
  -webkit-animation: rotate 1s linear infinite;
  -moz-animation: rotate 1s linear infinite;
  -o-animation: rotate 1s linear infinite;
  animation: rotate 1s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>